import { EnumValue } from '@coveo/bueno';
import { createAction } from '@reduxjs/toolkit';
import { validatePayload } from '../../../utils/validate-payload.js';
import { SortBy } from './sort.js';
export const applySort = createAction('commerce/sort/apply', (payload) => validatePayload(payload, {
    by: new EnumValue({
        enum: SortBy,
        required: true,
    }),
}));
